import { Link } from 'react-router-dom';

const footerLinks = {
  热门分类: [
    { label: '电影', path: '/category/movie' },
    { label: '电视剧', path: '/category/tv' },
    { label: '综艺', path: '/category/variety' },
    { label: '动漫', path: '/category/anime' },
    { label: '纪录片', path: '/category/documentary' },
    { label: '少儿', path: '/category/kids' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系我们', path: '/about#contact' },
    { label: '常见问题', path: '/#faq' },
    { label: '用户协议', path: '/about' },
  ],
  热门推荐: [
    { label: '影视资讯', path: '/articles' },
    { label: '观影指南', path: '/articles' },
    { label: '深度影评', path: '/articles' },
    { label: '动漫推荐', path: '/articles' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="site-container py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-film-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                蚂蚁影视
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              高清免费在线观看平台
              <br />
              不缓冲，畅快追剧
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 蚂蚁影视 MAntFilm. 保留所有权利
          </p>
          <p className="text-xs text-background-500">
            ICP备案号：粤ICP备2026XXXXXX号
          </p>
        </div>
      </div>
    </footer>
  );
}